import React, { useMemo, useState } from 'react'
import { motion } from 'motion/react'

import { EffectBackgroundProps, ParticleData } from '../types'

export const ParticlesFlowEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#6366f1'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const particleColor = effectColors[0] || '#6366f1'
  const flowDirection = 'horizontal' // Default to horizontal

  const [particles] = useState(() => {
    const particleCount = 50
    const newParticles: Array<ParticleData> = []
    for (let i = 0; i < particleCount; i++) {
      newParticles.push({
        id: i,
        startY: Math.random() * 100,
        delay: Math.random() * 3,
        duration: 3 + Math.random() * 2,
        size: 2 + Math.random() * 4,
        x: 0,
        y: 0,
      })
    }
    return newParticles
  })

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          style={{
            position: 'absolute',
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            backgroundColor: particleColor,
            boxShadow: `0 0 ${particle.size! * 2}px ${particleColor}`,
            opacity: opacityValue,
            borderRadius: '50%',
          }}
          initial={
            flowDirection === 'horizontal'
              ? {
                  left: '-10%',
                  top: `${particle.startY}%`,
                }
              : {
                  left: `${particle.startY}%`,
                  top: '-10%',
                }
          }
          animate={
            flowDirection === 'horizontal'
              ? {
                  left: '110%',
                  top: `${particle.startY}%`,
                }
              : {
                  left: `${particle.startY}%`,
                  top: '110%',
                }
          }
          transition={{
            duration: particle.duration! * (100 / Math.max(effectSpeed, 1)),
            repeat: Infinity,
            ease: 'linear',
            delay: particle.delay,
          }}
        />
      ))}
    </div>
  )
})
ParticlesFlowEffect.displayName = 'ParticlesFlowEffect'
